<span class="cart-payment"
  ><img [class]="'svg_' + payment" [alt]="payment" loading="lazy" [src]="'assets/svg/carts/' + payment + '.svg'"
/></span>
